import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** A plain object: not null, not an array */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value)
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
